'use strict';

(function () {
    angular
        .module('tracking')
        .component('trackingComponent', {
            templateUrl: 'tracking/components/tracking-component.tpl.html',
            controller: function ($timeout, $scope, $stateParams, $window, $interval, applicationConstants, EventManagerService, TrackingHelper, MessageService,
                                  StyleGenerator, trackingConstants, StorageServices, TabService, CrewingHelper, PopupManager, TrackingModel, ContextMenuService) {
                var vm = this;

                vm.viewModel = {
                    left_panel_width: 225,
                    hour_width: (Math.floor((screen.width - 225) / 24)) || 60,
                    minToPxRatio: 1,
                    headerHeight: 60,
                    row_height: 50,
                    scrollAreaWidth: '0px',
                    stylesTypes: {
                        trackingTimeline: 'trackingTimeline',
                        trackingFilterStyles: 'trackingFilterStyles',
                        trackingFlightSelection: 'trackingFlightSelection',
                        trackingCurrentTimeLine: 'trackingCurrentTimeLine',
                        hoursStyle: 'hoursStyle'
                    },
                    isCurrentTimeIndicatorVisible: false,
                    currentTimeTimer: null
                };

                vm.dataModel = {
                    hoursCol: [],
                    timeLineDataCol: [],
                    selectedFlight: null,
                    selectedPairing: null,
                    selectedDescrepency: null,
                    selectedDescrepencySubType: null,
                    selectedAssignedCrew: null,
                    selectedSuggestedCrew: null,
                    selectedCrewType: null,
                    selectedLanguageCode: null,
                    pairingsForSelectedFlight: null,
                    crewAssignedForSelectedPairing: null,
                    sugestedCrewList: null,
                    suggestedUnassignedCrewList: null,
                    filters: {
                        flags: {
                            isCrewCompositionFilterOn: false,
                            isExpiriesFilterOn: false,
                            isIllegalCurrentFilterOn: false,
                            isIllagalNextFilterOn: false,
                            isLabguageFilterOn: false,
                            isGenderFilerOn: false
                        },
                        uid: 0
                    },
                    flightToolTip: {
                        placement: '',
                        flight: null
                    },
                    currentTime: null,
                    lastRemovedYBYInfo: null
                };

                vm.selectedPairDetails = [];

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_CREW_COMPOSITION_ERROR, onCrewCompositionFilter);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_EXPIRIES_ERROR, onCrewExpiryFilter);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_CURRENT_DUTY, onIllgCurrentDuty);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_NEXT_DUTY, onNextDutyFilter);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_LANGUAGE_ERROR, onLangFilter);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.TRACKING.FILTER_BY_GENDER_ERROR, onGenderFilter);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TRACKING.GET_PAIRING_FOR_SELECTED_FLIGHT, onUpdateFlightPairings);

                if($(".tabbed-view-container").height() == 0)
                	$(".tabbed-view-container").height(80);

                var height=($("header").height() + $(".tabbed-view-container").height())+"px";
            	$(".canvas").css("top", height);

                vm.$onInit = function () {
                    createHoursCol();
                    vm.viewModel.minToPxRatio = vm.viewModel.hour_width / 60;

                    TrackingModel.flightSearchCriteria.subscribe(function (flightSearchCriteria) {
                            vm.searchRequest = flightSearchCriteria;
                            resetPreviousSelections();
                            createTimeLineData(vm.searchRequest);
                            setTrackingStyles(vm.viewModel.stylesTypes.trackingTimeline);
                            setTrackingStyles(vm.viewModel.stylesTypes.hoursStyle);
                        }
                    );

                    TrackingModel.flightSearchResult.subscribe(function (flightSearchResult) {
                        vm.trackingFlights = flightSearchResult;
                        onTrackingFlightUpdated();
                        $stateParams.day = null;
                    });

                    if( !vm.dataModel.filters.flags.isCrewCompositionFilterOn && $stateParams.day!= null){
                        $timeout(function(){
							$('#crewComposition').click();
                        });
                    }
                };

                vm.onFlightClick = function (clickedFlight, event) {
                  if (!(event.ctrlKey || event.metaKey)) {
                    if (vm.dataModel.selectedFlight == clickedFlight) {
                      resetPreviousSelections();
                    } else {
                      resetPreviousSelections();
                      vm.dataModel.selectedFlight = clickedFlight;
                      $timeout(function () {
                        TrackingHelper.getPairingsByFlightLegId(vm.dataModel.selectedFlight);
                        vm.dataModel.pairingsForSelectedFlight = TrackingHelper.pairingsForSelectedFlight(vm.dataModel.selectedFlight.flightLegId);
                        scrollToElementInFocus(event);
                      }, 300);
                    }
                    setTrackingStyles(vm.viewModel.stylesTypes.trackingFlightSelection);
                  }
                };


                vm.onPairingSelected = function (pairing) {
                    resetPreviousSelectedPairing();

                    vm.dataModel.selectedPairing = pairing;
                    TrackingHelper.setSelectedPairing(pairing);

                    getCrewForSelectedPairing(vm.dataModel.selectedPairing.patternId);
                };

                vm.onAssignedCrewSelected = function (crew) {
                    setSelectedAssignCrew(crew);
                };


                vm.onDiscrepancySelected = function (discrepancy, subTypes) {
                    resetPreviousSelectedDiscrepancy();
                    vm.dataModel.selectedDescrepency = discrepancy;
                    vm.dataModel.selectedDescrepencySubType = subTypes;
                    getSugestedCrewList();
                    getSuggestedUnassignedCrewList()
                };

                vm.onCancelSelectionClick = function () {
                    resetAndScrollTop();
                };

                vm.onViewProfile = function (crew) {
                    var tabName = 'crewSchedule';
                    var mo = moment(vm.searchRequest.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var moStart = moment(mo.startOf("month"));
                    var moEnd = moment(mo.endOf("month"));
                    var crewId = null;
                    if(!!crew.crewId){//when click on tracking assigned crew list
                    	crewId = crew.crewId;
                    }else if(!!crew.crewID){//when click on standby crew suggestion or unassigned crew list
                    	crewId = crew.crewID;
                    }
                    StorageServices.setTabData(tabName, 'crewingParams', {
                        crewId: crewId,
                        fromDate: moStart.format(applicationConstants.SETTINGS.DATE_FORMAT),
                        toDate: moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT)
                    });
                    TabService.gotoTab(tabName, {
                        crewId: crewId
                    });
                };

                vm.onAddCrew = function (crew, flag) {
                    vm.dataModel.selectedSuggestedCrew = crew;
                    var flags = {
                        isRequest: false,
                        isCallFromDayOff: false,
                        isContinueIllegal: true,
                        isUserConfirm: false,
                        mode: flag || null
                    };
                    if (CrewingHelper.isDistributionCheckApplicable('FLIGHT')) {
                        CrewingHelper.checkDistributionWarnings(crew.crewTypeMasterCode, vm.dataModel.selectedPairing.patternId,
                            crew.crewProfileId, false, assignCrewToPairing, flags);
                    } else {
                        assignCrewToPairing(flags);
                    }
                };

                vm.onSwapCrew = function (crew) {
                    var flags = {
                        isUserConfirm: false,
                        isIgnoreExpiry: false
                    };
                    vm.dataModel.selectedSuggestedCrew = crew;
                    swap(flags);
                };

                vm.onFlightHover = function (flight, event) {
                    vm.dataModel.flightToolTip.placement = findFlightTooltipPosition(event);
                    vm.dataModel.flightToolTip.flight = flight;
                };

                vm.onFilterClick = function () {
                    PopupManager.openModal('TRACKING_FLIGHT_FILTER', vm.filterCriteria, onFilterClose);
                };

            //load on right click
              vm.getContextMenuContent = function (type, duty) {
                if(type==='duty'){
                  return ContextMenuService.getContextMenu('CREW_WATCH_SEND_CREW_NOTIFICATION');
                }

              };

              EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SEND_CREW_NOTIFICATION, function (data) {

                if (data.modelValue.notificationItems.length == 0){
                  var notificationItem = {
                    flightLegId : data.items.flight.flightLegId
                  };
                  data.modelValue.notificationItems.push(notificationItem);
                }

                PopupManager.openModal('FLIGHT_SEND_NOTIFICATION', data, function () {
                  console.log("notificataion close handler")
                });
              });

              vm.getSelectedPairDetails = function(){
                var sendNotificationDetails = {};

                var notificationItems = [];
                vm.selectedPairDetails.forEach(function(p){
                  if(p.isSelected) {
                    var notificationItem = {
                      flightLegId : p.flightLegId
                    };
                    notificationItems.push(notificationItem);
                  }
                });
                sendNotificationDetails.notificationItems = notificationItems;
                sendNotificationDetails.successCallback = vm.clearSelectedItems;
                return sendNotificationDetails;
              };

              vm.clearSelectedItems = function(){
                vm.selectedPairDetails.length = 0;
              };

              vm.checkIsSelected = function(flight){
                var result = false;
                // search for existing object
                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                  return obj.flightLegId === flight.flightLegId;
                });

                if(selectedPairDetail !== undefined){
                  result = selectedPairDetail.isSelected;
                }
                return result;
              };

              // get selected flight leg indexes
              vm.checkIsMultiSelected = function(event, parentIndex, index, flight) {
                if (event.ctrlKey || event.metaKey) {
                  resetPreviousSelections();
                  setTrackingStyles(vm.viewModel.stylesTypes.trackingFlightSelection);
                  blockClickWithCtrlKey(event, parentIndex, index, flight);
                } else {
                  singleBlockClick(event, parentIndex, index, flight);
                }
              };

              vm.isNotOpenPairingData = function (index) {
                if(index > 0){
                  if(vm.trackingFlights[index].registrationName === vm.trackingFlights[index - 1].registrationName){
                    return false;
                  }
                }
                return true;
              };

              function blockClickWithCtrlKey(event, parentIndex, index, flight) {
                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                  return obj.flightLegId === flight.flightLegId
                });

                if(selectedPairDetail === undefined){
                  flight.isSelected = true;
                  vm.selectedPairDetails.push(flight);
                }else {
                  var index = vm.selectedPairDetails.indexOf(selectedPairDetail);
                  vm.selectedPairDetails[index].isSelected = !selectedPairDetail.isSelected;
                }
              }

              function singleBlockClick(event, parentIndex, index, flight) {
                // search for existing object
                var selectedPairDetail = _.find(vm.selectedPairDetails, function (obj) {
                  return obj.flightLegId === flight.flightLegId;
                });

                // reset the array
                vm.selectedPairDetails.length = 0;

                // another click
                if(selectedPairDetail === undefined){
                  flight.isSelected = true;
                  vm.selectedPairDetails.push(flight);
                } else {
                  flight.isSelected = !selectedPairDetail.isSelected;
                  vm.selectedPairDetails.push(flight);
                }
              }

              function onFilterClose(params) {
                if (!!params) {
                    var tmp = _.pluck(params, 'registrationName');
                    if (tmp.length > 0) {
                        TrackingHelper.applyFlightRegNoFilter(tmp);
                    } else {
                        TrackingHelper.cancelFlightRegFilter();
                    }
                }
              }

              function setSelectedAssignCrew(crew) {
                  vm.dataModel.selectedAssignedCrew = crew;
                  TrackingHelper.setSelectedCrew(crew);
                  getSugestedCrewList();
                  getSuggestedUnassignedCrewList();
              }


              function startCurrentTimeline() {
                  cancelCurrentTimeTimer();

                  vm.viewModel.currentTimeTimer = $interval(function () {
                      setCurrentTimeLineStyle();
                  }, 300000);

                  setCurrentTimeLineStyle(); //Execute Immediatly and every 5min;
              }

              function findFlightTooltipPosition(e) {
                  var bottomOffset = 150;
                  var popupSize = 250;
                  var H = 'left', V = 'top';
                  if ((e.clientX + e.target.offsetWidth + popupSize) > $window.innerWidth) {
                      H = 'left';
                  } else {
                      H = 'right';
                  }

                  if ((e.clientY  ) > ($window.innerHeight - bottomOffset)) {
                      V = 'bottom';
                  } else {
                      V = 'top';
                  }
                  return H + '-' + V;
              }

              function swap(flags) {
                  var existingCrew = vm.dataModel.selectedAssignedCrew;
                  var suggestedCrew = vm.dataModel.selectedSuggestedCrew;
                  TrackingHelper.swapCrewForPairing(existingCrew, suggestedCrew, flags,
                      function (response) {
                          swapCrewResponseActions(response, flags);
                      },
                      function (error) {
                          MessageService.error(error);
                      }
                  );
              }

              function assignCrewToPairing(flags) {
                  var assignedCrew = vm.dataModel.selectedSuggestedCrew;

                  var doAssign = function () {
                      var assignedCrew = vm.dataModel.selectedSuggestedCrew;
                      var crewProfileId = vm.dataModel.selectedSuggestedCrew && vm.dataModel.selectedSuggestedCrew.crewProfileId;
                      var patternId = vm.dataModel.selectedPairing.patternId;
                      TrackingHelper.assignCrewToPairing(crewProfileId, patternId, flags,
                          function (response) {
                              assignPairingResponseActions(response, flags, assignedCrew);
                          },
                          function (error) {
                              MessageService.error(error);
                          });
                  };

                  if (!!flags.isSBYRemoved) { //check if SBY is allready removed
                      doAssign();
                  } else {
                      if(flags.mode===null){
                          removeSBYForomSelectedSuggested(assignedCrew, function () {
                              doAssign();
                          });
                      }else{
                          doAssign();
                      }

                  }
              }


              function removeSBYForomSelectedSuggested(crew, onSuccess, onFail) {
                  var param = {
                      crewProfileId: crew.crewProfileId,
                      crewScheduleBlockId: crew.currCrewSchdBlockId
                  };

                  var doUnassign = function () {
                      TrackingHelper.unAssignCrew(param,
                          function (result) {
                              onSuccess();
                          },
                          function (error) {
                              onSuccess();  //proceed with assign operation even SBY removal fails
                              MessageService.error(error);
                          }
                      );
                  };

                  //Get SBY block details for rollback purpose
                  CrewingHelper.getBlockDetail(null, param.crewScheduleBlockId, null, function (blockDetails) {
                          vm.dataModel.lastRemovedYBYInfo = blockDetails;
                          vm.dataModel.lastRemovedYBYInfo.crewProfileId = crew.crewProfileId;
                          doUnassign();
                      },
                      function () {
                          vm.dataModel.lastRemovedYBYInfo = null;
                          doUnassign();
                      });
              }

              function rollbackSBYRemoval() {
                  var sby = vm.dataModel.lastRemovedYBYInfo;
                  var flags = {
                      isRequest: false,
                      isCallFromDayOff: false,
                      isContinueIllegal: true,
                      isUserConfirm: true
                  };
                  if (!!sby) {
                      var eventInfo = sby.scheduleEventScheduleDetails && sby.scheduleEventScheduleDetails[0];

                      if (!!eventInfo) {
                          var param = {
                              crewProfileId: sby.crewProfileId,
                              eventId: eventInfo.eventId,
                              request: sby.request,
                              calledFromDayOff: sby.callFromDayOff,
                              continueIllegal: true,
                              userConfirm: true,
                              startDate: eventInfo.startDateStr,
                              startTime: eventInfo.startTimeStr,
                              endDate: eventInfo.endDateStr,
                              endTime: eventInfo.endTimeStr,
                              startLocation: eventInfo.startLocation,
                              endLocation: eventInfo.endLocation,
                              eventOccuringFlight: null,
                              dutyPeriod: sby.dutyHours,
                              excludeFromPayment: true,
                              airportSBY: false,
                              aircraftType: vm.dataModel.selectedFlight.modelNo,
                              remarks: null
                          };
                          TrackingHelper.assignEvent(param,
                              function (assignEventData) {
                                  EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRACKING.GET_PAIRING_FOR_SELECTED_FLIGHT);
                              },
                              function (msg) {
                                  MessageService.error(msg);
                              }
                          );
                      }
                  }
              }

              function swapCrewResponseActions(swapResponse, flags) {
                  if (swapResponse.success) {
                      EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRACKING.GET_PAIRING_FOR_SELECTED_FLIGHT);
                      MessageService.success(MessageService.MESSAGES.TRACKING.TRACKING_SWAPP_CREW_SUCCESS);
                  } else if (swapResponse.crewWiseRegulationMap) {
                      var expiryMsg = CrewingHelper.isSwapExpiryMessage(swapResponse.crewWiseRegulationMap);
                      if (expiryMsg.length > 0) {
                          var param = {
                              title: 'Confirmation',
                              messages: expiryMsg,
                              flags: flags
                          };
                          PopupManager.openModal('CONFIRM_DIALOG', param, onSwapConfirmExpiryWarningsClose);
                      } else {
                          var regulationDetailParam = {
                              regulationMap: swapResponse.crewWiseRegulationMap,
                              onAcceptPassBackParam: {
                                  flags: flags
                              },
                              withGrouping: true
                          };
                          PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onSwapRegulationClose);
                      }
                  }
              }

              function onSwapConfirmExpiryWarningsClose(param) {
                  if (!!param) {
                      var flags = param.flags;
                      flags.isIgnoreExpiry = true;
                      swap(flags);
                  }
              }

              function onSwapRegulationClose(param) {
                  if (!!param) {
                      var flags = param.flags;
                      flags.isUserConfirm = true;
                      swap(flags);
                  }
              }

              function assignPairingResponseActions(assignParingResponse, flags, assignedCrew) {
                  if (!!assignParingResponse) {
                      if (assignParingResponse.success) {
                          EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRACKING.GET_PAIRING_FOR_SELECTED_FLIGHT);
                          MessageService.success(MessageService.MESSAGES.TRACKING.ASSIGN_CREW_TO_PAIRING_SUCCESS);
                          vm.dataModel.lastRemovedYBYInfo = null;
                          if (assignParingResponse.otherBlockIllegal) {
                              MessageService.warning(MessageService.MESSAGES.TRACKING.ASSIGN_CREW_OTHER_BLOCKS_ILLEGAL);
                          }
                      } else if (!!assignParingResponse.regulationMap) {
                          var regulationDetailParam = {
                              regulationMap: assignParingResponse.adaptedRegulationMap,
                              onAcceptPassBackParam: assignParingResponse
                          };
                          PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                      }
                  } else {
                      MessageService.error(MessageService.MESSAGES.COMMON.UNKNOWN_ERROR);
                      rollbackSBYRemoval();
                  }

                  function onCloseRegulationPopupForPairing(params) {
                      if (!!params) {
                          flags.isUserConfirm = true;
                          flags.isSBYRemoved = true;
                          assignCrewToPairing(flags);
                      } else {
                          rollbackSBYRemoval();
                      }
                  }
              }


              function scrollToElementInFocus(event) {
                  if (event && event.target) {
                      var offset = 350;
                      var scrollToPos = 0;
                      var clientRect = event.target.getBoundingClientRect();
                      if (clientRect.top) {
                          scrollToPos = clientRect.top - offset;
                          if (scrollToPos > 0) {
                              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL_TO_POINT, 'trackingGrid,' + scrollToPos);
                          }
                      }
                  }
              }

              function onCrewCompositionFilter() {
                  resetAndScrollTop();

                  vm.dataModel.filters.flags.isCrewCompositionFilterOn = !vm.dataModel.filters.flags.isCrewCompositionFilterOn;
                  // setTrackingStyles(vm.viewModel.stylesTypes.trackingFilterStyles);
              }

              function onCrewExpiryFilter() {
                  resetAndScrollTop();

                  vm.dataModel.filters.flags.isExpiriesFilterOn = !vm.dataModel.filters.flags.isExpiriesFilterOn;
                  // setTrackingStyles(vm.viewModel.stylesTypes.trackingFilterStyles);
              }

              function onIllgCurrentDuty() {
                  resetAndScrollTop();

                  vm.dataModel.filters.flags.isIllegalCurrentFilterOn = !vm.dataModel.filters.flags.isIllegalCurrentFilterOn;
                  // setTrackingStyles(vm.viewModel.stylesTypes.trackingFilterStyles);
              }

              function onNextDutyFilter() {
                  resetAndScrollTop();

                  vm.dataModel.filters.flags.isIllagalNextFilterOn = !vm.dataModel.filters.flags.isIllagalNextFilterOn;
                  // setTrackingStyles(vm.viewModel.stylesTypes.trackingFilterStyles);
              }

              function onLangFilter() {
                  resetAndScrollTop();

                  vm.dataModel.filters.flags.isLabguageFilterOn = !vm.dataModel.filters.flags.isLabguageFilterOn;
                  // setTrackingStyles(vm.viewModel.stylesTypes.trackingFilterStyles);
              }

              function onGenderFilter() {
                  resetAndScrollTop();
                  vm.dataModel.filters.flags.isGenderFilerOn = !vm.dataModel.filters.flags.isGenderFilerOn;
              }

              function onUpdateFlightPairings() {
                  TrackingHelper.resetPairingsForSelectedFilght(vm.dataModel.selectedFlight.flightLegId);
                  TrackingHelper.getPairingsByFlightLegId(vm.dataModel.selectedFlight);
                  vm.dataModel.pairingsForSelectedFlight = TrackingHelper.pairingsForSelectedFlight(vm.dataModel.selectedFlight.flightLegId);
              }

              function resetAndScrollTop() {
                  resetPreviousSelections();
                  setTrackingStyles(vm.viewModel.stylesTypes.trackingFlightSelection);
                  EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL_TO_TOP, 'trackingGrid');
              }

              function resetPreviousSelections() {
                  vm.dataModel.selectedFlight = null;
                  vm.dataModel.selectedPairing = null;
                  vm.dataModel.selectedDescrepency = null;
                  vm.dataModel.selectedAssignedCrew = null;
                  vm.dataModel.pairingsForSelectedFlight = null;
                  vm.dataModel.crewAssignedForSelectedPairing = null;
                  vm.dataModel.sugestedCrewList = null;
                  vm.dataModel.suggestedUnassignedCrewList=null;
              }

              function resetPreviousSelectedPairing() {
                  vm.dataModel.selectedPairing = null;
                  vm.dataModel.selectedDescrepency = null;
                  vm.dataModel.crewAssignedForSelectedPairing = null;
                  vm.dataModel.selectedAssignedCrew = null;
                  vm.dataModel.sugestedCrewList = null;
                  vm.dataModel.suggestedUnassignedCrewList=null;
              }

              function resetPreviousSelectedDiscrepancy() {
                  vm.dataModel.selectedDescrepency = null;
                  vm.dataModel.selectedAssignedCrew = null;
                  vm.dataModel.sugestedCrewList = null;
                  vm.dataModel.suggestedUnassignedCrewList=null;
              }

              function getCrewForSelectedPairing(patternId) {
                  TrackingHelper.getCrewForPairing(patternId, function (crewList) {
                      vm.dataModel.crewAssignedForSelectedPairing = crewList;
                  }, function (error) {
                      MessageService.error(error);
                  })
              }

              function getSugestedCrewList() {
                  var getGender = function () {
                      if (vm.dataModel.selectedDescrepency &&
                          (vm.dataModel.selectedDescrepency.type == trackingConstants.DESCRIPANCY_TYPES.GENDER_WARNING)) {
                          var genderCol = TrackingHelper.getGenderWarnings();
                          return _.pluck(genderCol, 'gender');
                      } else {
                          return [];
                      }
                  };

                  var getLanguage = function () {
                      var langCol = [];
                      if (vm.dataModel.selectedDescrepency &&
                          (vm.dataModel.selectedDescrepency.type == trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING)) {
                          var selection = vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING];
                          if (!!selection) {
                              angular.forEach(Object.keys(selection), function (type) {
                                  if (!!selection[type]) {
                                      langCol.push(type);
                                  }
                              });
                          } else {
                              var getLangCol = TrackingHelper.getLanguageWarnings();
                              langCol = _.pluck(getLangCol, 'languageCode');
                          }
                      }
                      return langCol;
                  };

                  var getCrewType = function () {
                      var crewTypes = [];
                      if (!!vm.dataModel.selectedAssignedCrew) {
                          crewTypes.push(vm.dataModel.selectedAssignedCrew.crewTypeCode);
                      } else {
                          if (!!vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR]) {
                              var selection = vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR];
                              angular.forEach(Object.keys(selection), function (type) {
                                  if (!!selection[type]) {
                                      crewTypes.push(type);
                                  }
                              });
                          } else {
                              var getOpenPairingCol = TrackingHelper.getOpenPairingWarning();
                              crewTypes = _.pluck(getOpenPairingCol, 'crewTypeCode');
                          }
                      }
                      return crewTypes;
                  };

                  var param = {
                      patternId: vm.dataModel.selectedPairing.patternId,
                      descrepency: vm.dataModel.selectedDescrepency.type,
                      crewType: getCrewType(),
                      gender: getGender(),
                      languageCode: getLanguage()
                  };


                  TrackingHelper.getSugestedCrewList(
                      param,
                      function (sugestedCrewList) {
                          vm.dataModel.sugestedCrewList = sugestedCrewList;
                      }, function (error) {
                          MessageService.error(error);
                      });

              };

              function getSuggestedUnassignedCrewList() {
                  var getGender = function () {
                      if (vm.dataModel.selectedDescrepency &&
                          (vm.dataModel.selectedDescrepency.type == trackingConstants.DESCRIPANCY_TYPES.GENDER_WARNING)) {
                          var genderCol = TrackingHelper.getGenderWarnings();
                          return _.pluck(genderCol, 'gender');
                      } else {
                          return [];
                      }
                  };

                  var getLanguage = function () {
                      var langCol = [];
                      if (vm.dataModel.selectedDescrepency &&
                          (vm.dataModel.selectedDescrepency.type == trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING)) {
                          var selection = vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING];
                          if (!!selection) {
                              angular.forEach(Object.keys(selection), function (type) {
                                  if (!!selection[type]) {
                                      langCol.push(type);
                                  }
                              });
                          } else {
                              var getLangCol = TrackingHelper.getLanguageWarnings();
                              langCol = _.pluck(getLangCol, 'languageCode');
                          }
                      }
                      return langCol;
                  };

                  var getCrewType = function () {
                      var crewTypes = [];
                      if (!!vm.dataModel.selectedAssignedCrew) {
                          crewTypes.push(vm.dataModel.selectedAssignedCrew.crewTypeCode);
                      } else {
                          if (!!vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR]) {
                              var selection = vm.dataModel.selectedDescrepencySubType[trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR];
                              angular.forEach(Object.keys(selection), function (type) {
                                  if (!!selection[type]) {
                                      crewTypes.push(type);
                                  }
                              });
                          } else {
                              var getOpenPairingCol = TrackingHelper.getOpenPairingWarning();
                              crewTypes = _.pluck(getOpenPairingCol, 'crewTypeCode');
                          }
                      }
                      return crewTypes;
                  };

                  var param = {
                      patternId: vm.dataModel.selectedPairing.patternId,
                      descrepency: vm.dataModel.selectedDescrepency.type,
                      crewType: getCrewType(),
                      gender: getGender(),
                      languageCode: getLanguage()
                  };


                  TrackingHelper.getSuggestedUnassignedCrewList(
                      param,
                      function (sugestedCrewList) {
                          vm.dataModel.suggestedUnassignedCrewList = sugestedCrewList;
                      }, function (error) {
                          MessageService.error(error);
                      });

              };

                function onTrackingFlightUpdated() {
                    //update filter to triger change in filter criteria
                    vm.dataModel.filters.uid++;

                    setTrackingStyles(vm.viewModel.stylesTypes.trackingTimeline);
                    setTrackingStyles(vm.viewModel.stylesTypes.trackingFlightSelection);
                    resetPreviousSelections();
                    renderFlights(vm.trackingFlights);
                    formatOpenPairings(vm.trackingFlights);
                    startCurrentTimeline();
                }

                function createTimeLineData(searchRequest) {
                    var moFromDate = moment(searchRequest.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    var moToDate = moment(searchRequest.toDate, applicationConstants.SETTINGS.DATE_FORMAT);

                    var diff = moToDate.diff(moFromDate, 'days') + 1;
                    vm.dataModel.timeLineDataCol.length = 0;
                    vm.viewModel.scrollAreaWidth = ((diff * 24 * vm.viewModel.hour_width) + vm.viewModel.left_panel_width) + 'px';

                    for (var i = 0; i < diff; i++) {
                        vm.dataModel.timeLineDataCol.push({
                            dateLbl: moment(moFromDate).add(i, 'd').format(applicationConstants.SETTINGS.DATE_FORMAT)
                        });
                    }
                }

                function renderFlights(flightData) {
                    angular.forEach(flightData, function (aircraft) {
                        angular.forEach(aircraft.pairs, function (pair) {
                            pair.left = vm.viewModel.left_panel_width + getPxicelForTimeInMin(
                                    pair.pairStartDate,
                                    pair.pairStartTime,
                                    vm.searchRequest.fromDate,
                                    '00:00',
                                    vm.viewModel.minToPxRatio);
                            pair.width = getPxicelForTimeInMin(
                                pair.pairEndDate,
                                pair.pairEndTime,
                                pair.pairStartDate,
                                pair.pairStartTime,
                                vm.viewModel.minToPxRatio
                            );

                            var lastFlightGroundTime = pair.flights[pair.flights.length - 1].groundTime;
                            if (!!lastFlightGroundTime) {
                                pair.width = pair.width += (lastFlightGroundTime * vm.viewModel.minToPxRatio);
                            }

                            angular.forEach(pair.flights, function (flight) {
                                var flightDepDate = flight.actDeptDate || flight.estDeptDate;
                                var flightDepTime = flight.actDeptTime || flight.estDeptTime;

                                var flightArrDate = flight.actArvlDate || flight.estArvlDate;
                                var flightArrTime = flight.estArvlTime || flight.estArvlTime;

                                flight.left = getPxicelForTimeInMin(
                                    flightDepDate,
                                    flightDepTime,
                                    pair.pairStartDate,
                                    pair.pairStartTime,
                                    vm.viewModel.minToPxRatio);
                                flight.width = getPxicelForTimeInMin(
                                    flightArrDate,
                                    flightArrTime,
                                    flightDepDate,
                                    flightDepTime,
                                    vm.viewModel.minToPxRatio
                                );

                                if (!!flight.groundTime) {
                                    flight.groundTimeLeft = flight.width;
                                    flight.groundTimeWidth = vm.viewModel.minToPxRatio * flight.groundTime;
                                }
                            });

                        });
                    });
                }

                function createHoursCol() {
                    vm.dataModel.hoursCol.length = 0;
                    for (var i = 0; i < 24; i++) {
                        vm.dataModel.hoursCol.push({
                            id: i + 1,
                            hourLbl: (i < 10) ? '0' + i : i
                        });
                    }
                }

                function getPxicelForTimeInMin(startDate, startTime, relativeToDate, relativeToTime, minToPxRatio) {
                    var moFromTime = moment(startDate + ' ' + startTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    var moRelativeTo = moment(relativeToDate + ' ' + relativeToTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    var diffFromStart = moFromTime.diff(moRelativeTo, 'm');
                    var px = Math.round(diffFromStart * minToPxRatio);
                    return px;
                }

                function getTimelineStyles() {
                    var str = '';
                    var screenHeight = $window.screen.height;
                    if (vm.trackingFlights.length > 0) {
                        var dayHeight = (vm.viewModel.row_height * vm.trackingFlights.length) + vm.viewModel.headerHeight;
                    } else {
                        dayHeight = screenHeight;
                    }
                    str += ('.tracking-component .canvas-wrapper .canvas-30day-temp .hour-lines-container .right .day .time .hour {height:' + dayHeight + 'px;}');
                    str += ('.tracking-component .canvas-wrapper .canvas-30day-temp .hour-lines-container .left {height:' + dayHeight + 'px;}');
                    str += ('.tracking-view .canvas .canvas-wrapper .canvas-30day-temp .right-section .right-section-table {height:' + dayHeight + 'px; width :' + vm.viewModel.scrollAreaWidth + '}');

                    return str;
                }

                function getFilterStyles() {
                    var str = '';
                    var isFilterEnable = false;
                    angular.forEach(Object.keys(vm.dataModel.filters.flags), function (key) {
                        isFilterEnable = isFilterEnable || vm.dataModel.filters.flags[key];
                    })
                    if (isFilterEnable) {
                        //Hide all
                        str += ('.flight-bar-colored {opacity:0;visibility: hidden;}');
                        if (vm.dataModel.filters.flags.isCrewCompositionFilterOn) {
                            str += ('.flight-bar-colored.CrewCom {opacity:1;visibility :visible}');
                        }
                        if (vm.dataModel.filters.flags.isIllagalNextFilterOn) {
                            str += ('.flight-bar-colored.IlgNext {opacity:1;visibility :visible}');
                        }
                        if (vm.dataModel.filters.flags.isExpiriesFilterOn) {
                            str += ('.flight-bar-colored.ExpCrew {opacity:1;visibility :visible}');
                        }
                        if (vm.dataModel.filters.flags.isIllegalCurrentFilterOn) {
                            str += ('.flight-bar-colored.IlgCurrent {opacity:1;visibility :visible}');
                        }
                        if (vm.dataModel.filters.flags.isLabguageFilterOn) {
                            str += ('.flight-bar-colored.LangWar {opacity:1;visibility :visible}');
                        }
                        if (vm.dataModel.filters.flags.isGenderFilerOn) {
                            str += ('.flight-bar-colored.GenWar {opacity:1;visibility :visible}');
                        }
                    } else {
                        str += ('.flight-bar-colored {opacity:1;visibility :visible}');
                    }
                    return str;
                }

                function getFlightSelectionStyles() {
                    var str = '';
                    if (!!vm.dataModel.selectedFlight) {
                        str += ('.flight-bar-colored{filter: opacity(0.2);}');
                        str += ('.flight-pairs{outline-color:rgba(0, 0, 0, 0.2) !important;}');
                        str += ('.tracking-component .canvas-wrapper .canvas-30day-temp .hour-lines-container .right .day .time .hour{border-right: 1px solid rgba(204, 215, 221, 0.31);}');
                        str += ('#fl_' + vm.dataModel.selectedFlight.flightLegId + '{filter:none}');
                    } else {
                        str += ('.flight-bar-colored{filter:none}');
                    }
                    return str;
                }

                function getHoursStyle () {
                    var str = '.tracking-component .time .hour{width :'+vm.viewModel.hour_width+'px;} .tracking-component .twentyfour-hour-view .right .time .hour{width:'+vm.viewModel.hour_width+'px !important;}';
                    return str;
                }

                function cancelCurrentTimeTimer() {
                    if (!!vm.viewModel.currentTimeTimer) {
                        $interval.cancel(vm.viewModel.currentTimeTimer);
                    }
                    vm.viewModel.isCurrentTimeIndicatorVisible = false;
                }

                function setCurrentTimeLineStyle() {
                    var styleString = '';

                    var isCurrentTimeWithInSearchReange = function (currentTime) {
                        var moCurrent = moment(currentTime.dateStr + ' ' + currentTime.timeStr, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                        var moSt = moment(vm.searchRequest.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        var moEnd = moment(vm.searchRequest.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        return moCurrent.isBetween(moSt, moEnd, null, '[]');
                    };

                    TrackingHelper.getCuttentTime(
                        function (currentTime) {
                            vm.dataModel.currentTime = currentTime;

                            if (isCurrentTimeWithInSearchReange(vm.dataModel.currentTime)) {
                                var left = vm.viewModel.left_panel_width + getPxicelForTimeInMin(
                                        currentTime.dateStr,
                                        currentTime.timeStr,
                                        vm.searchRequest.fromDate,
                                        '00:00',
                                        vm.viewModel.minToPxRatio);
                                vm.viewModel.isCurrentTimeIndicatorVisible = true;

                                if (vm.trackingFlights.length > 0) {
                                    styleString += ('.time-bar{left:' + left + 'px;}');
                                    StyleGenerator.addStyleTag(vm.viewModel.stylesTypes.trackingCurrentTimeLine, styleString);
                                }
                            } else {
                                cancelCurrentTimeTimer();
                            }
                        },
                        function () {
                            vm.viewModel.isCurrentTimeIndicatorVisible = false;
                            console.log('current time retreval error');
                        }
                    );
                }

                function setTrackingStyles(type) {
                    var styleString = '';
                    switch (type) {
                        case vm.viewModel.stylesTypes.trackingTimeline :
                        {
                            styleString = getTimelineStyles();
                            break;
                        }
                        case vm.viewModel.stylesTypes.trackingFilterStyles :
                        {
                            styleString = getFilterStyles()
                            break;
                        }
                        case vm.viewModel.stylesTypes.trackingFlightSelection :
                        {
                            styleString = getFlightSelectionStyles();
                            break;
                        }
                        case vm.viewModel.stylesTypes.hoursStyle :
                        {
                            styleString = getHoursStyle();
                            break;
                        }
                    }

                    if (!!styleString) {
                        StyleGenerator.addStyleTag(type, styleString);
                    }
                }

                function formatOpenPairings(flightData) {
                  var index = flightData.length-1;
                  var lastElement = flightData[index];
                  var openPairData = lastElement.pairs;

                  openPairData = TrackingHelper.trackingOpenFlightPairsAdaptor(openPairData);

                  var flightPairs = _.groupBy(openPairData,'rowIndex');

                  // remove last element
                  flightData.splice(index, 1);

                  angular.forEach(Object.keys(flightPairs), function (dateKey) {
                    var tempOpenPairings = {
                      id: index,
                      modelNumber: "",
                      registrationID: null,
                      registrationName: "TBA",
                      sharket: null,
                      base: "",
                      pairs: flightPairs[dateKey],
                      pairsUntouch: flightPairs[dateKey]
                    };
                    flightData.push(tempOpenPairings);
                  });
                }

            },
            bindings: {
                trackingFlights: '<'
            }
        });
})();
